import { useDocumentTitle, siteTitle } from "@1-now/booking-core";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { useData } from "data/data-provider";
import BgGlassmorphism from "designs/DesignA/components/BgGlassmorphism/BgGlassmorphism";

export interface ListingCarPageProps {
  className?: string;
}

const ListingCarPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  // "Vehicles — <operator>", always (1NOW-11189, Faiza 7 Oct). It used to be the operator's
  // SEO title whenever one was set, so Vehicles read as the home page's title. The SEO title is
  // the site's title: the header gives it to every page that has none of its own.
  useDocumentTitle(companyDetails ? siteTitle(companyDetails, "Vehicles") : undefined);
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <BgGlassmorphism />

      <div className="container relative">
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default ListingCarPage;
